export enum SyncStatus {
  NotSynced = 0,
  Syncing = 1,
  Synced = 2,
  Failed = 3,
}

export const getSyncStatusDisplayName = (status: SyncStatus | string): string => {
  // Convert string to enum if needed
  let syncStatus: SyncStatus;
  
  if (typeof status === 'string') {
    // Handle string representation from API
    switch (status) {
      case 'NotSynced': syncStatus = SyncStatus.NotSynced; break;
      case 'Syncing': syncStatus = SyncStatus.Syncing; break;
      case 'Synced': syncStatus = SyncStatus.Synced; break;
      case 'Failed': syncStatus = SyncStatus.Failed; break;
      default: return 'Unknown';
    }
  } else {
    syncStatus = status;
  }

  switch (syncStatus) {
    case SyncStatus.NotSynced:
      return 'Not Synced';
    case SyncStatus.Syncing:
      return 'In Progress';
    case SyncStatus.Synced:
      return 'Completed';
    case SyncStatus.Failed:
      return 'Failed';
    default:
      return 'Unknown';
  }
};
